var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-input-radio__wrap"},[_c('label',{staticClass:"c-input-radio__label",class:[
      ("-" + _vm.kind),
      {
        '-checked': _vm.checked === _vm.value,
        '-disabled': _vm.disabled
      }
    ]},[_c('span',{staticClass:"c-input-radio__icon__wrap",style:({
        borderColor: _vm.checked === _vm.value && _vm.kind === 'main' ? _vm.colorCode : ''
      })},[_c('input',{staticClass:"c-input-radio",class:{
          'c-input-radio--error': _vm.error
        },attrs:{"type":"radio","name":_vm.name,"error":_vm.error,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked === _vm.value},on:{"change":_vm.updateValue}}),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked === _vm.value),expression:"checked === value"}],staticClass:"c-input-radio__icon",style:({ backgroundColor: _vm.kind === 'main' ? _vm.colorCode : '' })})]),_c('span',{staticClass:"c-input-radio__text"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }